import type { ReactNode } from 'react'
import { ContentLoading } from '@/components/ContentLoading'
import styles from './JobSection.module.css'
import { JobNavigation } from '@/features/call-center/components/JobNavigation'
import { pluralize } from '@/utils/pluralization-util'
import { ContactCard } from '@/features/call-center/ClientDetails'
import { Button } from '@/components/Button'

export interface JobSectionProps {
  isInitializing: boolean
  hasActiveClient: boolean
  hasJobCreation: boolean
  contact: {
    fullName: string
    email: string
    phone: string
    workspace: string
  }
  requiredQuestionsAmount: number
  form: ReactNode
  onPrevious: () => unknown
  canProceed: boolean
  next?: string
}

export function JobSection(props: JobSectionProps) {
  return (
    <div className={styles.root}>
      <div className={styles.main}>{renderMainPanel(props)}</div>
    </div>
  )
}

function renderMainPanel({
  isInitializing,
  hasActiveClient,
  hasJobCreation,
  contact,
  requiredQuestionsAmount,
  form,
  onPrevious,
  canProceed,
  next,
}: JobSectionProps) {
  if (isInitializing) {
    return <ContentLoading size="inline" />
  }

  if (!hasActiveClient) {
    return <div className={styles.placeholder}>No active job.</div>
  }

  if (!hasJobCreation) {
    return null
  }

  return (
    <>
      <ContactCard
        fullName={contact.fullName}
        email={contact.email}
        phone={contact.phone}
        workspace={contact.workspace}
      />
      <div className={styles.guidance}>
        {requiredQuestionsAmount > 0 ? (
          <>
            Answer the first{' '}
            {pluralize(
              'question',
              requiredQuestionsAmount,
              `${requiredQuestionsAmount} questions`,
            )}
            . Remaining questions are optional.
          </>
        ) : (
          <>All questions are optional. Provide as much detail as you can.</>
        )}
      </div>
      {form}
      <JobNavigation
        secondaryAction={
          <Button
            label="Previous"
            variant="secondary"
            onPress={() => onPrevious()}
          />
        }
        canProceed={canProceed}
        next={next}
      />
    </>
  )
}
